<template>
  <div class="flex">
    <input
      class="form-control"
      :disabled="disabled"
      type="text"
      placeholder="Выберите время"
      v-model="displayDate"
    />
    <button type="button" class="btn btn-info" v-if="!disableEdit" @click="open = !open">
      <i class="icon-fa icon-fa-clock-o"></i>
    </button>
    <date-picker
      class="small_date"
      v-model="date"
      :open.sync="open"
      @change="dateUpdated"
      type="datetime"
      :shortcuts="shortcuts"
      :disabled-date="disabledDates"
      valueType="format"
      :minute-step="30"
      format="DD.MM.YYYY HH:mm"
      placeholder="Выберите прибытие">
    </date-picker>
  </div>
</template>

<script>
// import {Datetime} from 'vue-datetime'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'
import moment from 'moment'

export default {
  components: {
    // Datetime,
    DatePicker
  },
  props: ['selectedDate', 'onSelect', 'disabled', 'useDisabledDates', 'customShortCutsArray', 'customShortCutsDates', 'disableEdit'],
  data() {
    return {
      max_date: null,
      min_date: null,
      displayDate: null,
      date: new Date(),
      formatDate: null,
      open: false,
      activeShortcuts: [],
      shortcuts: [
        {
          text: 'Сегодня',
          onClick() {
            const date = new Date()
            return date
          }
        },
        {
          text: 'Завтра',
          onClick() {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24)
            return date
          }
        },
        {
          text: 'После завтра',
          onClick() {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 48)
            return date
          }
        }
      ]
    }
  },
  mounted() {
    if (this.selectedDate) {
      // this.date = new Date(moment(this.selectedDate).format("YYYY-MM-DD"));
      this.displayDate = moment(this.selectedDate).format('DD.MM.YYYY HH:mm')
    }
    if (this.customShortCutsArray) {
      this.shortcuts = [...this.customShortCutsArray];
    }
    if (this.customShortCutsDates) {
      let shortCuts = [];
      switch (this.customShortCutsDates) {
        case 'orderNotifications':
          shortCuts = [
            {
              text: 'Через 30м',
              onClick() {
                const date = new Date()
                return new Date(date.getTime() + 30 * 60000);
              }
            },
            {
              text: 'Через час',
              onClick() {
                const date = new Date()
                return new Date(date.getTime() + 60 * 60000);
              }
            },
            {
              text: 'Через 2ч',
              onClick() {
                const date = new Date()
                return new Date(date.getTime() + 120 * 60000);
              }
            },
            {
              text: 'Завтра',
              onClick() {
                const date = new Date()
                date.setTime(date.getTime() + (24 * 60 * 60 * 1000))
                return date
              }
            }
          ]
          break;
        default:
          shortCuts = [
            {
              text: 'Сегодня',
              onClick() {
                const date = new Date()
                return date
              }
            }
          ]
          this.customShortCutsDates.forEach((c) => {
            let range = c.days * 24 * 60 * 60 * 1000
            if (c.increment === 'minus') range *= -1
            shortCuts.push({
              text: c.title,
              onClick() {
                const date = new Date()
                date.setTime(date.getTime() + range)
                return date
              }
            })
          })
          break;
      }
      this.shortcuts = [...shortCuts]
    }
  },
  watch: {
    selectedDate(val) {
      // handler: function (val, oldVal) {
      // console.log(val)
      // this.displayDate = moment(this.selectedDate).format('DD.MM.YYYY HH:mm')
      // this.date = val
      //   if (this.selectedDate) {
      //     console.log("selectedDate updated", this.selectedDate);
      //     // this.date = this.selectedDate;
      //     this.date = new Date(moment(this.selectedDate).format("YYYY-MM-DD"));
      //     this.displayDate = moment(this.selectedDate).format("DD.MM.YYYY");
      //   }
      // },
      // deep: true
    }
  },
  methods: {
    dateSelected(e) {
      // console.log(1, e)
    },
    dateUpdated(e, type) {
      // console.log(e)
      const selected = moment(e, 'DD.MM.YYYY HH:mm')
      // const minutes = selected.minute();
      // if (minutes > 0 && minutes !== 30 && minutes < 30) {
      //   selected.set('minute', 0);
      // } else {
      //   selected.set('minute', 30);
      // }
      // console.log(selected);
      this.formatDate = selected.format('YYYY-MM-DD HH:mm:00')
      this.displayDate = e
      // this.displayDate = selected.format('DD.MM.YYYY HH:mm');
      if (this.onSelect) {
        // console.log(selected, selected.format('YYYY-MM-DD HH:mm:00'))
        this.onSelect(selected.format('YYYY-MM-DD HH:mm:00'))
      }
      if (type === 'minute') {
        this.open = false;
      }
    },
    moment: function (date, format = 'DD.MM.YYYY', object = false) {
      if (!date) return
      const objectDate = moment(date)
      if (object) return objectDate
      return objectDate.format(format)
    },
    disabledDates(date) {
      if (this.useDisabledDates === false) return false
      let today = new Date()
      if (this.useDisabledDates !== true) {
        today = new Date(this.useDisabledDates);
      }
      today.setHours(0, 0, 0, 0)
      return date < today
    }
  }
}
</script>

<style>
.small_date {
  width: 10px;
}

.small_date input,
.small_date i {
  display: none;
}
</style>

<style scoped>
.btn {
  text-align: center;
}

.btn,
input {
  border-radius: 0;
}
</style>
